import { useEffect } from 'react';
import { useAirportFilterChanges } from '@components/Filters/Components/AirportFilter/Provider';
import { useOrderFilterTagsActions } from './OrderedFilterTagsProvider';
import { useConnectionThresholdFilterChanges } from '@components/Filters/Components/MaxStopsFilter/Provider';
import { useCarrierFilterChanges } from '@components/Filters/Components/CarrierFilter/Provider';

const useDispatchChangesEffect = (filterChanges) => {
  const { dispatch } = useOrderFilterTagsActions();
  useEffect(() => filterChanges.forEach(dispatch), [dispatch, filterChanges]);
};

export default function FilterTagsProvider({ children }) {
  const airportFilterChanges = useAirportFilterChanges();
  const connectionThresholdChanges = useConnectionThresholdFilterChanges();
  const carrierFilterChanges = useCarrierFilterChanges();

  useDispatchChangesEffect(connectionThresholdChanges);
  useDispatchChangesEffect(airportFilterChanges);
  useDispatchChangesEffect(carrierFilterChanges);

  return children;
}
